import { OnInit } from '@angular/core';
import { BillingService } from '../services/billing.service';
import { BillingDetails } from '../models/billing-details';
import { AlertService } from '../../shared/services/alert.service';
import { DacConfig } from '../services/dac-config.service';
var BillingDetailsComponent = /** @class */ (function () {
    function BillingDetailsComponent(billingService, alertService, dacConfig) {
        this.billingService = billingService;
        this.alertService = alertService;
        this.dacConfig = dacConfig;
        this.billingDetails = new BillingDetails();
    }
    Object.defineProperty(BillingDetailsComponent.prototype, "hasSubscription", {
        get: function () {
            return this.billingDetails.subscriptions.length > 0;
        },
        enumerable: true,
        configurable: true
    });
    BillingDetailsComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.loading = true;
        this.billingService.getBillingDetails()
            .then(function (details) {
            _this.billingDetails = details;
            _this.loading = false;
        })
            .catch(function (error) {
            _this.loading = false;
            console.error(error);
            _this.alertService.error("Failed to retrieve billing details from server.  Check your network connection and refresh the page.");
        });
    };
    Object.defineProperty(BillingDetailsComponent.prototype, "Billing", {
        get: function () {
            return this.billingDetails;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(BillingDetailsComponent.prototype, "supportEmail", {
        get: function () {
            return this.dacConfig.supportEmail;
        },
        enumerable: true,
        configurable: true
    });
    BillingDetailsComponent.prototype.setupCard = function () {
        var _this = this;
        this.billingService.updateDefaultBillingCard(this.billingDetails)
            .then(function (updatedBillingDetails) {
            _this.billingDetails = updatedBillingDetails;
            _this.alertService.success("Default billing card updated");
        })
            .catch(function (error) {
            console.error(error);
            _this.alertService.error("There was an error updating your default billing card.  Please try again or contact customer support");
        });
    };
    BillingDetailsComponent.prototype.removeCard = function () {
        var _this = this;
        if (confirm("Are you sure you want to delete this card?")) {
            this.billingService.deleteDefaultBillingCard(this.billingDetails)
                .then(function (billingDetails) {
                _this.billingDetails = billingDetails;
                _this.alertService.success("Deleted billing card");
            });
        }
    };
    return BillingDetailsComponent;
}());
export { BillingDetailsComponent };



// WEBPACK FOOTER //
// ./src/app/shared/billing-details/billing-details.component.ts.pre-build-optimizer.js